import {styled} from 'quickstart/theme/linaria'

export const Numeric = styled.span`
  font-variant-numeric: tabular-nums;
`
